"use strict";
import "../api/api";
import "select2";
import DOMPurify from "dompurify";
const EmailTypeAhead = React.createClass({
  componentDidMount: function() {
    this.loadSelect();
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("select", { ref: "recipients", multiple: "multiple", style: { display: "none" } });
  },
  formattedRecipients: function() {
    return _.map(this.props.recipients, (email) => ({ email }));
  },
  localResults: function() {
    return [
      ...this.formattedRecipients(),
      ...this.contactsWithoutRecipients()
    ];
  },
  matchedLocalResults: function(term) {
    function matchesTerm(text) {
      return text && text.toLowerCase().includes(term.toLowerCase());
    }
    function itemMatchesTerm(item) {
      return !term || matchesTerm(item.email) || matchesTerm(item.title) || matchesTerm(item.name);
    }
    return this.localResults().filter(itemMatchesTerm);
  },
  contactsWithoutRecipients: function() {
    return _.reject(this.props.contacts, (contact) => {
      return (this.props.recipients || []).indexOf(contact.email) >= 0;
    });
  },
  formatContact: function(contact) {
    return {
      id: contact.email,
      text: contact.email,
      contact
    };
  },
  changed: function() {
    this.props.onChange(this.$element().val() || []);
  },
  $element() {
    return $(this.refs.recipients);
  },
  loadSelect: function() {
    var component = this;
    const $element = this.$element();
    $element.select2({
      ajax: {
        url: "/api/contacts/search",
        dataType: "json",
        delay: 100,
        data: function(term) {
          return {
            query: term
          };
        },
        processResults: (data, params) => {
          params.page = params.page || 1;
          const localResults = component.matchedLocalResults(params.term);
          const remoteResults = params.term ? data.contacts : [];
          const results = [
            ..._.sortBy(localResults, "email"),
            ..._.sortBy(remoteResults, "email")
          ].map(this.formatContact);
          return { results };
        },
        cache: true
      },
      escapeMarkup: (markup) => DOMPurify.sanitize(markup),
      templateResult: this.itemTemplate,
      tags: true,
      placeholder: "email addresses, comma or space separated"
    });
    if (this.props.selectByDefault) {
      _.each(
        this.props.recipients,
        (recipient) => {
          $element.append($("<option>", {
            value: recipient,
            text: recipient
          }));
        }
      );
      $element.val(this.props.recipients);
    }
    $element.on("change", this.changed);
    $element.trigger("change");
    $element.on("select2:unselect", this.changed);
    switch (this.props.focusBehavior) {
      case "focus":
        $element.select2("focus");
        break;
    }
  },
  itemTemplate(item) {
    if (item.contact) {
      let renderField2 = function(field) {
        return `<div title='${field.field}'>${field.value}</div>`;
      };
      var renderField = renderField2;
      const fieldsToShow = [
        { field: "Name", value: item.contact.name },
        { field: "Email", value: item.contact.email },
        { field: "Title", value: item.contact.title }
      ].filter((x) => x.value);
      const fields = fieldsToShow.map(renderField2).join("");
      return `<div style="display: flex; gap: 25px;">${fields}</div>`;
    }
    return item.text;
  }
});
export default EmailTypeAhead;
